(function() {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initPanZoom() {
    var wrappers = document.querySelectorAll('.js-zoom-enabled');
    wrappers.forEach(function(wrapper) {
      var img = wrapper.querySelector('.product-featured-media');
      if (!img) return;

      wrapper.addEventListener('mousemove', function(e) {
        var rect = wrapper.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      wrapper.addEventListener('mouseleave', function() {
        img.style.transformOrigin = 'center center';
      });
    });
  }

  function initThumbnailActive() {
    var thumbItems = document.querySelectorAll('.product-single__thumbnails-item');
    if (thumbItems.length === 0) return;

    thumbItems.forEach(function(item) {
      var link = item.querySelector('.product-single__thumbnail');
      if (!link) return;
      link.addEventListener('click', function() {
        thumbItems.forEach(function(t) { t.classList.remove('kc-thumb-active'); });
        item.classList.add('kc-thumb-active');
      });
    });

    // Marca activo el thumbnail que realmente muestra la imagen destacada
    // (el que el theme marca con .active-thumb), no siempre el primero.
    // Evita que se vean 2 seleccionadas cuando la destacada no es el index 0.
    var initial = null;
    thumbItems.forEach(function(item) {
      var link = item.querySelector('.product-single__thumbnail.active-thumb');
      if (link && !initial) initial = item;
    });
    (initial || thumbItems[0]).classList.add('kc-thumb-active');
  }

  function initDetailReveal() {
    if (reducedMotion) {
      var blocks = document.querySelectorAll('.kc-detail-block');
      blocks.forEach(function(b) { b.classList.add('kc-detail-visible'); });
      return;
    }

    var blocks = document.querySelectorAll('.kc-detail-block');
    if (blocks.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kc-detail-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -20px 0px' });

    blocks.forEach(function(block) { observer.observe(block); });
  }

  function initAddToCartFeedback() {
    var form = document.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', function() {
      var btn = form.querySelector('[type="submit"], .product-form__cart-submit');
      if (!btn || reducedMotion) return;
      btn.classList.add('kc-atc-pulse');
      setTimeout(function() { btn.classList.remove('kc-atc-pulse'); }, 600);
    });
  }

  function initRecommendationsRelocation() {
    var slot = document.querySelector('.ko-pdp__recs-slot');
    if (!slot) return;

    var recs = document.querySelector('.product-recommendations');
    if (!recs) return;
    var wrapper = recs.closest('.shopify-section') || recs;
    slot.appendChild(wrapper);
  }

  function init() {
    initPanZoom();
    initThumbnailActive();
    initDetailReveal();
    initAddToCartFeedback();
    initRecommendationsRelocation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* La descripción se administra desde Shopify admin; el theme no la manipula. */

/* ── Judge.me v3 sobre el PDP oscuro: si el widget monta un shadow root,
      el CSS del theme no entra; se inyecta una hoja de estilos adentro
      con los mismos colores claros. Complementa el barrido que hay en
      product-premium.css para el caso de DOM normal. ── */
(function () {
  var host = document.getElementById('judgeme_product_reviews');
  if (!host) return;

  var CSS =
    'h1,h2,h3,h4,h5,p,div,a,label,legend,small,time,li,dt,dd,strong,em{color:rgba(255,255,255,0.85)!important}' +
    "span:not([class*='star' i]):not([class*='icon' i]){color:rgba(255,255,255,0.85)!important}" +
    'a{text-decoration-color:rgba(255,255,255,0.4)}' +
    'input,textarea,select{background:rgba(255,255,255,0.06)!important;color:#fff!important;border:1px solid rgba(255,255,255,0.25)!important}' +
    '::placeholder{color:rgba(255,255,255,0.4)!important}';

  var painted = [];
  function paint(root) {
    if (!root || painted.indexOf(root) !== -1) return;
    var st = document.createElement('style');
    st.textContent = CSS;
    root.appendChild(st);
    painted.push(root);
  }

  function scan() {
    if (host.shadowRoot) paint(host.shadowRoot);
    var all = host.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) paint(all[i].shadowRoot);
    }
  }

  /* el widget carga tarde y sin avisar: se reintenta ~25s y listo */
  var tries = 0;
  var timer = setInterval(function () {
    scan();
    if (++tries >= 36) clearInterval(timer);
  }, 700);
})();
